const cleanObject = (obj: unknown): unknown => {
  if (typeof obj !== 'object' || Array.isArray(obj)) return obj;
  return Object.keys(obj).reduce((acc, key) => {
    if (obj[key] === undefined) return acc;
    return { ...acc, [key]: obj[key] };
  }, {});
};

export default cleanObject;
